import * as React from "react";
import { ChevronDown } from "lucide-react";
import { cn } from "@/lib/utils";

interface NativeSelectProps extends Omit<React.SelectHTMLAttributes<HTMLSelectElement>, "onChange"> {
  options: { value: string; label: string }[];
  onValueChange: (value: string) => void;
  /** Klass för omslaget (t.ex. hidden md:inline-flex). */
  wrapperClassName?: string;
}

/**
 * Inbyggd select med samma utseende som våra rundade kontroller. Används i
 * sidhuvud och priskontroller i stället för Radix Select, som är för tung för
 * kontroller som finns på nästan alla sidor (~22 kB).
 */
const NativeSelect = React.forwardRef<HTMLSelectElement, NativeSelectProps>(
  ({ options, onValueChange, className, wrapperClassName, ...props }, ref) => (
    <div className={cn("relative inline-flex", wrapperClassName)}>
      <select
        ref={ref}
        onChange={(e) => onValueChange(e.target.value)}
        className={cn(
          "h-9 cursor-pointer appearance-none rounded-full border border-border bg-card pl-4 pr-9 text-sm font-medium text-foreground ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2",
          className,
        )}
        {...props}
      >
        {options.map((o) => (
          <option key={o.value} value={o.value}>
            {o.label}
          </option>
        ))}
      </select>
      <ChevronDown
        className="pointer-events-none absolute right-3 top-1/2 size-4 -translate-y-1/2 opacity-50"
        aria-hidden="true"
      />
    </div>
  ),
);
NativeSelect.displayName = "NativeSelect";

export { NativeSelect };
